var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-05 col-xl-3 col-md-3 col-sm-6" }, [
    _c("div", { staticClass: "card pb-5" }, [
      _c("div", { staticClass: "shadow" }, [
        _c("a", { attrs: { href: "/event/" + _vm.event.slug } }, [
          _c("img", {
            staticClass: "card-img-top img-fluid ",
            staticStyle: { "object-fit": "cover" },
            attrs: {
              src:
                _vm.event.event_image !== null
                  ? _vm.event.event_image.url
                  : "/images/cover.jpg",
              alt: "Cover image",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-body pt-05 p-1" }, [
          _c("a", { attrs: { href: "/event/" + _vm.event.slug } }, [
            _c("h6", { staticClass: "text-bold-700 mb-0 mt-05" }, [
              _vm._v(" " + _vm._s(_vm.event.title)),
            ]),
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "/event/" + _vm.event.slug } }, [
            _c(
              "p",
              {
                staticClass: "event-text primary font-small-1 mt-05 mb-05",
                staticStyle: { "line-height": "1.4em" },
              },
              [
                _c("i", { staticClass: "feather icon-calendar" }),
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.event.event_start_end_date) +
                    "\n                    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.event.event_privacy
            ? _c(
                "div",
                {
                  staticClass: "badge badge-pill ",
                  staticStyle: { padding: "0.2rem 0.5rem" },
                },
                [
                  _c("i", { staticClass: "feather icon-award" }),
                  _vm._v(" "),
                  _vm._t("premium_label"),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.event.access === "Hybrid Event"
            ? _c(
                "div",
                {
                  staticClass: "badge badge-pill bg-gradient-warning",
                  staticStyle: { padding: "0.2rem 0.5rem" },
                },
                [
                  _c("i", { staticClass: "feather icon-calendar" }),
                  _vm._v(" "),
                  _vm._t("hybrid_label"),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.event.access === "Online Event"
            ? _c(
                "div",
                {
                  staticClass: "badge badge-pill bg-gradient-success",
                  staticStyle: { padding: "0.2rem 0.5rem" },
                },
                [
                  _c("i", { staticClass: "feather icon-globe" }),
                  _vm._v(" "),
                  _vm._t("online_label"),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.event.access === "Offline Event"
            ? _c(
                "div",
                {
                  staticClass: "badge badge-pill bg-gradient-secondary",
                  staticStyle: { padding: "0.2rem 0.5rem" },
                },
                [
                  _c("i", { staticClass: "feather icon-user-plus" }),
                  _vm._v(" "),
                  _vm._t("offline_label"),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.service_settings.description_display
            ? _c("div", {
                staticClass: "card-content event-description font-small-4 mt-1",
                domProps: { innerHTML: _vm._s(_vm.description) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "card-bottom mt-1 d-flex font-small-3 align-items-center",
            },
            [
              _vm.sold_out
                ? _c(
                    "div",
                    {
                      staticClass: "badge badge-pill badge-danger font-small-2",
                      staticStyle: { padding: "0.2rem 0.5rem" },
                    },
                    [
                      _c("i", { staticClass: "feather icon-alert-circle" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("event.sold_out")) +
                          "\n                    "
                      ),
                    ]
                  )
                : _vm.price !== null
                ? _c(
                    "div",
                    { staticClass: "text-bold-700 font-small-2 text-light" },
                    [
                      _c("span", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.__("globals.from")) +
                              " " +
                              _vm._s(
                                _vm._f("currency")(_vm.price, _vm.site_tax)
                              )
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.event.disabled === 1
                ? _c("div", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "badge badge-pill bg-danger mb-05 text-bold-700 font-small-2 ",
                      },
                      [
                        _c("i", { staticClass: "feather icon-alert-circle" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.__("event.event_inactive")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-sm btn-flat-light ml-auto",
                  staticStyle: { border: "none" },
                },
                [
                  _c("a", { attrs: { href: "/event/" + _vm.event.slug } }, [
                    _vm._v(_vm._s(_vm.__("globals.view")) + " "),
                    _c("i", { staticClass: "feather icon-chevron-right" }),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }